export default "__VITE_ASSET__BMHZ0ehg__"